export default "__VITE_ASSET__DVs6mDm4__"